import { RiskKeys } from '@components/EntityDrawers/drawers/Risk/keys';
import ControlledTextFieldSelect from '@components/Inputs/controllers/ControlledTextFieldSelect';
import { ISelectOption } from '@constants/entities/ui';
import { useProject } from '@context/Project/ProjectProvider';
import useProjectSettings from '@hooks/useProjectSettings';
import { transformArrayToOptions } from '@utils/helpers';
import { settingsRowToString } from '@views/ProjectSettings/components/ProjectDetailsSettings/helpers/helpers';
import { useMemo } from 'react';

const TaxonomyDropdown = () => {
  const { viewOnly } = useProject();

  const {
    settings: { risk_taxonomy },
  } = useProjectSettings();

  const options: ISelectOption[] = useMemo(
    () =>
      transformArrayToOptions((risk_taxonomy ?? []).map(settingsRowToString)),
    [risk_taxonomy],
  );

  return (
    <ControlledTextFieldSelect
      name={RiskKeys.Taxonomy}
      label="Risk taxonomy"
      placeholder="Choose risk taxonomy"
      disabled={viewOnly}
      options={options}
      resetOnDoubleClick
    />
  );
};

export default TaxonomyDropdown;
